/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { OptimizedAgentMemoryControllerOptimizeMutationRequest, OptimizedAgentMemoryControllerOptimizeMutationResponse, OptimizedAgentMemoryControllerOptimize400, OptimizedAgentMemoryControllerOptimize401, OptimizedAgentMemoryControllerOptimize403, OptimizedAgentMemoryControllerOptimize404 } from "../../models/optimizedAgentMemoriesController/OptimizedAgentMemoryControllerOptimize";

function getOptimizedAgentMemoryControllerOptimizeUrl() {
  const res = { method: 'POST', url: `/api/v1/optimized-agent-memories` as const }  
  return res
}

/**
 * @summary Optimize user AI agent memory profile content
 * {@link /api/v1/optimized-agent-memories}
 */
export async function optimizedAgentMemoryControllerOptimize(data?: OptimizedAgentMemoryControllerOptimizeMutationRequest, config: Partial<RequestConfig<OptimizedAgentMemoryControllerOptimizeMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<OptimizedAgentMemoryControllerOptimizeMutationResponse, ResponseErrorConfig<OptimizedAgentMemoryControllerOptimize400 | OptimizedAgentMemoryControllerOptimize401 | OptimizedAgentMemoryControllerOptimize403 | OptimizedAgentMemoryControllerOptimize404>, OptimizedAgentMemoryControllerOptimizeMutationRequest>({ method : "POST", url : getOptimizedAgentMemoryControllerOptimizeUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}